import React, { useEffect, useState, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import {post_data} from './Javascript/API_Calls.js';
import {toggle_download_button} from './Javascript/General.js';
import './CSS/style.css';
import * as RO from './Javascript/ReportObjects';
import * as G from './Javascript/General';
import { generate_report_route, add_markers } from './Javascript/GenerateReport.js';
import {map_conversion_handler, image_conversion} from './Javascript/DownloadPDF.js';

interface Props {
  report_data: RO.report_info | null;
  markers: RO.Location[] | null;
  map_ref: any;
  path_points?: RO.Location[] | null;
}

const MapComponent: React.FC<Props> = ({ report_data, map_ref, markers, path_points}) => {
  const [mapSuccess, setMapSuccess] = useState(true);
  const [nearestPortPos, setNearestPortPos] = useState({});

  const ReportMap = () =>{
      useEffect(() => {
          mapboxgl.accessToken = 'pk.eyJ1IjoibWFyaWRhdGEiLCJhIjoiY2s1Zml3MGFzMmJ5bzNrbXU0MWI3bno4MCJ9.N5idq0WLbrkeGb0EDSJfug';
          const map = new mapboxgl.Map({
              container: map_ref.current,
              style: 'mapbox://styles/maridata/ckdooni5328q91imrr61vqbeh',
              center: [0, 0],
              attributionControl: false,
              minZoom: 0,
              collectResourceTiming: true,
              preserveDrawingBuffer: true,
          });

          map.on('style.load', () => {
              const currentMap = map;

              const waitForStyle = () => {
              try{
                  if (!currentMap.isStyleLoaded()) {
                      setTimeout(waitForStyle, 200);
                  } else {
                    (async () => {
                       if (report_data) {
                           await generate_report_route(report_data, map_ref.current);
                       } else if (path_points) {
                           await generate_report_route(path_points, map_ref.current);
                       }

                     G.checkMapLayers(map_ref.current);

                       if (markers) {
                           await add_markers(map_ref.current, markers, nearestPortPos);
                       }
                       //G.checkMapLayers(map_ref.current);
                    })();
                  }
              }catch(ex) {
                  console.error(ex);
              }
          };

          waitForStyle();});

          map_ref.current = map;
          let mapImageComplete = false;
          const container = document.getElementById("map_image_download");
          if (container) {
            const images = container.querySelectorAll("img");
            images.forEach(img => img.remove());
          }
          return () => {
          };
      }, []);

      return <div ref={map_ref} id="report_map"></div>;
  };

  const call_generate_map_image = async () =>{
      toggle_download_button();
      await map_conversion_handler(map_ref.current);
      toggle_download_button();
  };
  const call_map_update = async () =>{
      toggle_download_button();
      await map_ref.current.on('style.load', () => {
      const waitForStyle = () => {
          try{
              if (!map_ref.current.isStyleLoaded()) {
                  setTimeout(waitForStyle, 200);
              } else {
                  (async () => {
                     if (report_data) {
                         await generate_report_route(report_data, map_ref.current);
                     } else if (path_points) {
                         await generate_report_route(path_points, map_ref.current);
                     }
                     G.checkMapLayers(map_ref.current);

                     if (markers) {
                         await add_markers(map_ref.current, markers, nearestPortPos);
                     }
                     //G.checkMapLayers(map_ref.current);
                  })();
              }
          }
          catch (ex){
            console.error(ex);
          }
      };
      waitForStyle();
      });
      toggle_download_button();
  };

  useEffect(() => {
     const fetch_status = async () => {
        if(markers && markers.length > 0) {
            let param = { "Location": { "Dec" : { "Lat" : markers[0].dec.lat, "Lon" : markers[0].dec.lon} } };
            const nearest_port = await post_data("/get_NearestPortPosition", param) || null;
            setNearestPortPos( { "lon" :nearest_port[0].location.dec.lon, "lat" : nearest_port[0].location.dec.lat } );
        }
     }
     fetch_status();
  }, [markers]);
  useEffect(() => {
      toggle_download_button();
  }, [report_data, markers, nearestPortPos, path_points]);

  return (
  <>
      <style>
          {` #report_map { height:100%; } `}
      </style>

      <button style={{display:'none'}} type="button" id="add_route_incidents_to_map" onClick={call_map_update}>Add Incidents</button>
      <div>
          {RO.report_type == "0" ? (<p className="sub_title">Route</p>) : (null)}
          <div className="clear_both"></div>
          <div className="map_image_container">
              <div id="map_image_object">
                <ReportMap />
                <div id="map_image_download"></div>
              </div>
          </div>
          <div id='map_logo_bar'>
              <div className='left'><img src={RO.host_logo}/> </div>
              <div className='right'><p>{RO.host_url}</p> </div>
          </div>
      </div>
  </>
  );
};

export default MapComponent;